/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  placeholder: 'Выберите время'
};
export default locale;
//# sourceMappingURL=ru_RU.js.map
